import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('my-modal', {
    attrs: {
      "width": 800,
      "data-sign": "finance_bill_data_log_modal",
      "title": _vm.rowData.title
    },
    on: {
      "cancel": _vm.handleClose
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('a-skeleton', {
    attrs: {
      "active": "",
      "loading": _vm.loadingStatus
    }
  }, [_c('my-table', {
    attrs: {
      "bordered": "",
      "data-sign": "finance_bill_data_log_list",
      "columns": _vm.columns,
      "data-source": _vm.dataList,
      "is-filter-box": "",
      "pagination": false
    },
    scopedSlots: _vm._u([{
      key: "index",
      fn: function (ref) {
        var index = ref.index;
        return _c('span', {}, [_vm._v(_vm._s(index + 1))]);
      }
    }])
  })], 1), _c('my-pagination', {
    staticClass: "mt-20",
    attrs: {
      "value": _vm.searchData.page_index,
      "total": _vm.total,
      "page-size": _vm.searchData.page_size
    },
    on: {
      "update:pageSize": function ($event) {
        return _vm.$set(_vm.searchData, "page_size", $event);
      },
      "update:page-size": function ($event) {
        return _vm.$set(_vm.searchData, "page_size", $event);
      },
      "onChange": _vm.handlePageChange
    }
  }), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('a-button', {
    attrs: {
      "data-sign": "finance_bill_data_log_cancel",
      "fbu-analyse-name": $t("\u53D6\u6D88")
    },
    on: {
      "click": _vm.handleClose
    }
  }, [_vm._v(_vm._s(_vm.t('取消')))])], 1)], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };